import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center"
            aria-label="Ir al inicio"
          >
            <div className="w-7 h-7 md:w-12 md:h-12 rounded-full bg-primary-500 flex items-center justify-center overflow-hidden">
              <img
                src="https://static.readdy.ai/image/3ac88beca320db2f961147cc19b75475/c966e299d7275505654852a65f959d1a.png"
                alt="Logo Baños Run"
                className="w-full h-full object-cover"
              />
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-3">
            <span className="px-4 py-2 rounded-full bg-primary-500 text-white text-sm font-semibold whitespace-nowrap">
              18 JUL 2026
            </span>
            <Link
              to="/recorrido"
              className="px-4 py-2 rounded-full border border-primary-500 text-primary-500 text-sm font-semibold hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              RECORRIDO
            </Link>
            <Link
              to="/reglamento"
              className="px-4 py-2 rounded-full border border-primary-500 text-primary-500 text-sm font-semibold hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              REGLAMENTO
            </Link>
            <Link
              to="/verificar"
              className="px-4 py-2 rounded-full border border-primary-500 text-primary-500 text-sm font-semibold hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              VERIFICAR
            </Link>
            <Link
              to="/inscribirse"
              className="px-5 py-2 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              INSCRIBIRSE
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl`} />
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-background-200 px-4 py-4 space-y-3">
          <span className="block px-4 py-2 rounded-full bg-primary-500 text-white text-sm font-semibold text-center">
            18 JUL 2026
          </span>
          <Link
            to="/recorrido"
            className="block px-4 py-2 rounded-full border border-primary-500 text-primary-500 text-sm font-semibold text-center"
            onClick={() => setMobileMenuOpen(false)}
          >
            RECORRIDO
          </Link>
          <Link
            to="/reglamento"
            className="block px-4 py-2 rounded-full border border-primary-500 text-primary-500 text-sm font-semibold text-center"
            onClick={() => setMobileMenuOpen(false)}
          >
            REGLAMENTO
          </Link>
          <Link
            to="/verificar"
            className="block px-4 py-2 rounded-full border border-primary-500 text-primary-500 text-sm font-semibold text-center"
            onClick={() => setMobileMenuOpen(false)}
          >
            VERIFICAR
          </Link>
          <Link
            to="/inscribirse"
            className="block px-4 py-2 rounded-full bg-primary-500 text-white text-sm font-semibold text-center"
            onClick={() => setMobileMenuOpen(false)}
          >
            INSCRIBIRSE
          </Link>
        </div>
      )}
    </nav>
  );
}